import dynamic from 'next/dynamic';

export const DynamicAppHeader = dynamic(
  () => import('./index').then((mod) => mod.AppHeader),
  {
    ssr: false,
  },
);
